declare global {
  interface Window {
    _env_?: Record<string, string>;
  }
}

const BACKEND_URL = window._env_?.REACT_APP_BACKEND_URL || process.env.REACT_APP_BACKEND_URL;
const WHY = window._env_?.REACT_APP_WHY || process.env.REACT_APP_WHY;
const WHERE = window._env_?.REACT_APP_WHERE || process.env.REACT_APP_WHERE;
const HEADROOM = window._env_?.REACT_APP_HEADROOM || process.env.REACT_APP_HEADROOM;
const REALITY = window._env_?.REACT_APP_REALITY || process.env.REACT_APP_REALITY;
const EXPECTATION = window._env_?.REACT_APP_EXPECTATION || process.env.REACT_APP_EXPECTATION;
const VISUAL = window._env_?.REACT_APP_VISUAL || process.env.REACT_APP_VISUAL;
const WHY_TABLE = window._env_?.REACT_APP_WHY_TABLE || process.env.REACT_APP_WHY_TABLE;
const AZURE_BLOB_URL = window._env_?.REACT_APP_AZURE_BLOB_URL || process.env.REACT_APP_AZURE_BLOB_URL;
const AZURE_SAS_TOKEN = window._env_?.REACT_APP_AZURE_SAS_TOKEN || process.env.REACT_APP_AZURE_SAS_TOKEN;
export { BACKEND_URL, WHY, WHERE, REALITY, EXPECTATION, VISUAL, WHY_TABLE, AZURE_BLOB_URL, AZURE_SAS_TOKEN, HEADROOM };
